import UserLoginModal from "@/components/auth-modals/user-login-modal";
import UserRegisterModal from "@/components/auth-modals/user-register-modal";
import { useAuthContext } from "@/context/auth/useAuthContext";

const AuthModalWrapper = ({ children }) => {
  const {
    isRegisterModelOpen,
    setIsRegisterModelOpen,
    isLoginModalOpen,
    setIsLoginModalOpen,
  } = useAuthContext();

  return (
    <>
      {isLoginModalOpen ? (
        <UserLoginModal
          isLoginModalOpen={isLoginModalOpen}
          setIsLoginModalOpen={setIsLoginModalOpen}
          isRegisterModelOpen={isRegisterModelOpen}
          setIsRegisterModelOpen={setIsRegisterModelOpen}
        />
      ) : (
        <UserRegisterModal
          isLoginModalOpen={isLoginModalOpen}
          setIsLoginModalOpen={setIsLoginModalOpen}
          isRegisterModelOpen={isRegisterModelOpen}
          setIsRegisterModelOpen={setIsRegisterModelOpen}
        />
      )}
      {children}
    </>
  );
};

export default AuthModalWrapper;
